// Color display name mapping based on Intro.md Section 11.2
export const COLOR_DISPLAY_NAMES = {
  'white': 'Soft White',
  'ivory': 'Porcelain Ivory',
  'black': 'Carbon Black',
  'teal blue': 'Tide Teal',
  'atomic pink': 'Atomic Pink',
  'ryobix green': 'Ryobix Green',
  'lemon yellow': 'Citrus Yellow',
  'orange': 'Solar Orange'
};

// Helper function to get display name for a color
export function getColorDisplayName(colorId) {
  if (!colorId) return '';

  // Try exact match first
  if (COLOR_DISPLAY_NAMES[colorId]) {
    return COLOR_DISPLAY_NAMES[colorId];
  }

  // Try case-insensitive match
  const lowerColorId = colorId.toLowerCase();
  if (COLOR_DISPLAY_NAMES[lowerColorId]) {
    return COLOR_DISPLAY_NAMES[lowerColorId];
  }

  // If no match, capitalize the original ID
  return colorId
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
